export default [
  {"id":"01","name":"小学"},{"id":"02","name":"初中"},{"id":"03","name":"高中、中专"},
  {"id":"04","name":"专科"},{"id":"05","name":"本科"},{"id":"06","name":"硕士"},
  {"id":"07","name":"博士"},{"id":"08","name":"其他"}
];